export default {"src":"/_next/static/media/arrow-back.98840642.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};